import React from 'react';
import { Button } from './ui/button';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';

const CartButton = () => {
  const { getCartCount, setIsCartOpen } = useCart();
  const count = getCartCount();

  if (count === 0) return null;

  return (
    <Button
      onClick={() => setIsCartOpen(true)}
      className="fixed bottom-6 right-6 h-16 w-16 rounded-full bg-[#EA580C] hover:bg-[#C2410C] text-white shadow-2xl hover:shadow-xl transition-all z-50"
      data-testid="floating-cart-button"
    >
      <ShoppingCart className="h-6 w-6" />
      <span
        className="absolute -top-2 -right-2 bg-[#7F1D1D] text-white text-xs font-bold rounded-full h-7 w-7 flex items-center justify-center"
        style={{ fontFamily: 'Outfit, sans-serif' }}
        data-testid="cart-count-badge"
      >
        {count}
      </span>
    </Button>
  );
};

export default CartButton;